/**
 * @description 药房管理
 * @author maruirui
 * @since 2021-01-07
 */
import PHARMACYMANAGE from '@/api/modules/pharmacyManage'

const pharmacy = {
  namespaced: true,
  state: {
    pharmacistOptions: [], // 全部药商
    authPharmacistOptions: [], // 权限-全部药商
    takeOptions: [], // 服用方式
    wholePackage: [], // 整包装单位
    doseUnit: [], // 计费单位
    meterUnit: [], // 计量单位
    selectPharmacOptions: [], // 列表筛选条件
    authPharmacOptions: [] // 权限-列表筛选条件
  },
  mutations: {
    setPharmacistList(state, data = []) {
      const defaultOptions = [{ pharmaceuticalCompanyId: '', pharmaceuticalCompanyName: '全部' }]
      state.pharmacistOptions = data
      state.selectPharmacOptions = defaultOptions.concat(data)
    },
    authPharmacistList(state, data = []) {
      const defaultOptions = [{ pharmaceuticalCompanyId: '', pharmaceuticalCompanyName: '全部' }]
      state.authPharmacistOptions = data
      state.authPharmacOptions = defaultOptions.concat(data)
    },
    setTakeOptions(state, data = []) {
      state.takeOptions = data
    },
    // 设置整包装单位
    setPackageUnit(state, data = []) {
      state.wholePackage = data
    },
    // 设置计费单位
    setDoseUnit(state, data = []) {
      state.doseUnit = data
    },
    // 设置计量单位
    setMeterUnit(state, data = []) {
      state.meterUnit = data
    }
  },
  actions: {
    // 查询全部药商
    async queryPharmacistList({ commit }, params = {}) {
      try {
        const { data } = await PHARMACYMANAGE.queryAllPharmacist(params)
        commit('setPharmacistList', data)
        return Promise.resolve(data)
      } catch (err) {
        return Promise.reject(err)
      }
    },

    // 权限-查询全部药商
    async queryAuthPharmacist({ commit }, params = {}) {
      try {
        const { data } = await PHARMACYMANAGE.getAuthAllPharmacist(params)
        commit('authPharmacistList', data)
        return Promise.resolve(data)
      } catch (err) {
        return Promise.reject(err)
      }
    },

    // 查询服用方式
    async queryTakeMethods({ commit }, params = {}) {
      try {
        const { data } = await PHARMACYMANAGE.queryTakeMethods(params)
        commit('setTakeOptions', data)
        return Promise.resolve(data)
      } catch (err) {
        return Promise.reject(err)
      }
    },

    // 查询整包装单位（1）
    // 计费单位（3）
    // 计量单位（4）
    async queryDrugUnitByType({ commit }, params = {}) {
      try {
        const { data } = await PHARMACYMANAGE.findDrugUnitByType(params)
        switch (params.type) {
          case 1:
            commit('setPackageUnit', data)
            break
          case 3:
            commit('setDoseUnit', data)
            break
          case 4:
            commit('setMeterUnit', data)
            break
        }
        return Promise.resolve(data)
      } catch (err) {
        return Promise.reject(err)
      }
    }
  },
}

export default pharmacy



// WEBPACK FOOTER //
// ./src/pages/pharmacyManage/store/modules/pharmacy.js